module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.metrics !== null) ? _c('div', [_c('b-breadcrumb', [_c('b-breadcrumb-item', {
    attrs: {
      "text": "Home",
      "to": "/"
    }
  }), _vm._v(" "), _c('b-breadcrumb-item', {
    attrs: {
      "text": "Dashboard",
      "to": "/dashboard"
    }
  }), _vm._v(" "), _c('b-breadcrumb-item', {
    attrs: {
      "text": _vm.metrics.server.name,
      "active": true
    }
  })], 1), _vm._v(" "), (_vm.metrics !== null) ? _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-row', [_c('b-col', {
    staticClass: "mt-2 mb-2",
    attrs: {
      "lg": "6",
      "md": "6",
      "sm": "12",
      "xs": "12"
    }
  }, [_c('collapsible-card', {
    attrs: {
      "title": "Server Info",
      "visible": true
    }
  }, [_c('table', {
    staticClass: "table table-striped table-hover table-bordered"
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("Name")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.metrics.server.name))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Hostname")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.metrics.server.hostname))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Group")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.metrics.server.group))])])])]), _vm._v(" "), _c('table', {
    staticClass: "table table-striped table-hover table-bordered"
  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Free")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Used")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Total")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("CPU")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  }, [_vm._v(_vm._s(_vm._f("percentage")(_vm.metrics.current.cpu.idle)))]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  }, [_vm._v(_vm._s(_vm._f("percentage")(_vm.metrics.current.cpu.usage)))]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("RAM")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  }, [_vm._v(_vm._s(_vm._f("size")(_vm.metrics.current.memory.free)))]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  }, [_vm._v(_vm._s(_vm._f("size")(_vm.metrics.current.memory.used)))]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  }, [_vm._v(_vm._s(_vm._f("size")(_vm.metrics.current.memory.free + _vm.metrics.current.memory.used)))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Swap")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  }, [_vm._v(_vm._s(_vm._f("size")(_vm.metrics.current.swap.free)))]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  }, [_vm._v(_vm._s(_vm._f("size")(_vm.metrics.current.swap.used)))]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  }, [_vm._v(_vm._s(_vm._f("size")(_vm.metrics.current.swap.free + _vm.metrics.current.swap.used)))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Disk")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  }, [_vm._v(_vm._s(_vm._f("size")(_vm.metrics.current.disk.free)))]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  }, [_vm._v(_vm._s(_vm._f("size")(_vm.metrics.current.disk.used)))]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  }, [_vm._v(_vm._s(_vm._f("size")(_vm.metrics.current.disk.free + _vm.metrics.current.disk.used)))])])])])])], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2 mb-2",
    attrs: {
      "lg": "6",
      "md": "6",
      "sm": "12",
      "xs": "12"
    }
  }, [_c('b-card', {
    attrs: {
      "header-tag": "header",
      "footer-tag": "footer"
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function() {
        return [_c('b-row', [_c('b-col', {
          attrs: {
            "cols": "9"
          }
        }, [_c('h4', {
          staticClass: "card-title"
        }, [_vm._v("Server Status")])]), _vm._v(" "), _c('b-col', {
          staticClass: "text-right",
          attrs: {
            "cols": "3"
          }
        }, [_c('icon', {
          attrs: {
            "name": "server",
            "scale": "1"
          }
        })], 1)], 1)]
      },
      proxy: true
    }], null, false, 2645026208)
  }, [_vm._v(" "), _c('b-card-text', [_c('bar-chart', {
    ref: "summaryChart",
    attrs: {
      "chartData": _vm.summary.chartData,
      "options": _vm.summary.chartOptions,
      "height": 375
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2 mb-2",
    attrs: {
      "lg": "3",
      "md": "3",
      "sm": "6",
      "xs": "12"
    }
  }, [_c('b-card', {
    attrs: {
      "header-tag": "header",
      "footer-tag": "footer"
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function() {
        return [_c('b-row', [_c('b-col', {
          attrs: {
            "cols": "9"
          }
        }, [_c('h4', {
          staticClass: "card-title"
        }, [_vm._v("CPU")])]), _vm._v(" "), _c('b-col', {
          staticClass: "text-right",
          attrs: {
            "cols": "3"
          }
        }, [_c('icon', {
          attrs: {
            "name": "microchip",
            "scale": "1"
          }
        })], 1)], 1)]
      },
      proxy: true
    }], null, false, 2159769082)
  }, [_vm._v(" "), _c('b-card-text', [_c('doughnut-chart', {
    ref: "cpuPieChart",
    attrs: {
      "chartData": _vm.cpu.pie.chartData,
      "options": _vm.cpu.pie.chartOptions
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2 mb-2",
    attrs: {
      "lg": "9",
      "md": "9",
      "sm": "6",
      "xs": "12"
    }
  }, [_c('b-card', {
    scopedSlots: _vm._u([{
      key: "header",
      fn: function() {
        return [_c('b-row', [_c('b-col', {
          attrs: {
            "cols": "9"
          }
        }, [_c('h4', {
          staticClass: "card-title"
        }, [_vm._v("CPU Trend")])]), _vm._v(" "), _c('b-col', {
          staticClass: "text-right",
          attrs: {
            "cols": "3"
          }
        }, [_c('icon', {
          attrs: {
            "name": "microchip",
            "scale": "1"
          }
        })], 1)], 1)]
      },
      proxy: true
    }], null, false, 3667682035)
  }, [_vm._v(" "), _c('b-card-text', [_c('line-chart', {
    ref: "cpuTrendChart",
    attrs: {
      "chartData": _vm.cpu.trend.chartData,
      "options": _vm.cpu.trend.chartOptions
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2 mb-2",
    attrs: {
      "lg": "3",
      "md": "3",
      "sm": "6",
      "xs": "12"
    }
  }, [_c('b-card', {
    scopedSlots: _vm._u([{
      key: "header",
      fn: function() {
        return [_c('b-row', [_c('b-col', {
          attrs: {
            "cols": "9"
          }
        }, [_c('h4', {
          staticClass: "card-title"
        }, [_vm._v("Memory")])]), _vm._v(" "), _c('b-col', {
          staticClass: "text-right",
          attrs: {
            "cols": "3"
          }
        }, [_c('icon', {
          attrs: {
            "name": "memory",
            "scale": "1"
          }
        })], 1)], 1)]
      },
      proxy: true
    }], null, false, 1372592084)
  }, [_vm._v(" "), _c('b-card-text', [_c('doughnut-chart', {
    ref: "memoryPieChart",
    attrs: {
      "chartData": _vm.memory.pie.chartData,
      "options": _vm.memory.pie.chartOptions
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2 mb-2",
    attrs: {
      "lg": "9",
      "md": "9",
      "sm": "6",
      "xs": "12"
    }
  }, [_c('b-card', {
    scopedSlots: _vm._u([{
      key: "header",
      fn: function() {
        return [_c('b-row', [_c('b-col', {
          attrs: {
            "cols": "9"
          }
        }, [_c('h4', {
          staticClass: "card-title"
        }, [_vm._v("Memory")])]), _vm._v(" "), _c('b-col', {
          staticClass: "text-right",
          attrs: {
            "cols": "3"
          }
        }, [_c('icon', {
          attrs: {
            "name": "memory",
            "scale": "1"
          }
        })], 1)], 1)]
      },
      proxy: true
    }], null, false, 1372592084)
  }, [_vm._v(" "), _c('b-card-text', [_c('line-chart', {
    ref: "memoryTrendChart",
    attrs: {
      "chartData": _vm.memory.trend.chartData,
      "options": _vm.memory.trend.chartOptions
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2 mb-2",
    attrs: {
      "lg": "3",
      "md": "3",
      "sm": "6",
      "xs": "12"
    }
  }, [_c('b-card', {
    ref: "memory",
    scopedSlots: _vm._u([{
      key: "header",
      fn: function() {
        return [_c('b-row', [_c('b-col', {
          attrs: {
            "cols": "9"
          }
        }, [_c('h4', {
          staticClass: "card-title"
        }, [_vm._v("Swap")])]), _vm._v(" "), _c('b-col', {
          staticClass: "text-right",
          attrs: {
            "cols": "3"
          }
        }, [_c('icon', {
          attrs: {
            "name": "memory",
            "scale": "1"
          }
        })], 1)], 1)]
      },
      proxy: true
    }], null, false, 90687552)
  }, [_vm._v(" "), _c('b-card-text', [_c('doughnut-chart', {
    ref: "swapPieChart",
    attrs: {
      "chartData": _vm.swap.pie.chartData,
      "options": _vm.swap.pie.chartOptions
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2 mb-2",
    attrs: {
      "lg": "9",
      "md": "9",
      "sm": "6",
      "xs": "12"
    }
  }, [_c('b-card', {
    scopedSlots: _vm._u([{
      key: "header",
      fn: function() {
        return [_c('b-row', [_c('b-col', {
          attrs: {
            "cols": "9"
          }
        }, [_c('h4', {
          staticClass: "card-title"
        }, [_vm._v("Swap")])]), _vm._v(" "), _c('b-col', {
          staticClass: "text-right",
          attrs: {
            "cols": "3"
          }
        }, [_c('icon', {
          attrs: {
            "name": "memory",
            "scale": "1"
          }
        })], 1)], 1)]
      },
      proxy: true
    }], null, false, 90687552)
  }, [_vm._v(" "), _c('b-card-text', [_c('line-chart', {
    ref: "swapTrendChart",
    attrs: {
      "chartData": _vm.swap.trend.chartData,
      "options": _vm.swap.trend.chartOptions
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2 mb-2",
    attrs: {
      "lg": "3",
      "md": "3",
      "sm": "6",
      "xs": "12"
    }
  }, [_c('b-card', {
    scopedSlots: _vm._u([{
      key: "header",
      fn: function() {
        return [_c('b-row', [_c('b-col', {
          attrs: {
            "cols": "9"
          }
        }, [_c('h4', {
          staticClass: "card-title"
        }, [_vm._v("Disk")])]), _vm._v(" "), _c('b-col', {
          staticClass: "text-right",
          attrs: {
            "cols": "3"
          }
        }, [_c('icon', {
          attrs: {
            "name": "hdd",
            "scale": "1"
          }
        })], 1)], 1)]
      },
      proxy: true
    }], null, false, 2122568809)
  }, [_vm._v(" "), _c('b-card-text', [_c('doughnut-chart', {
    ref: "disksPieChart",
    attrs: {
      "chartData": _vm.disks.pie.chartData,
      "options": _vm.disks.pie.chartOptions
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2 mb-2",
    attrs: {
      "lg": "9",
      "md": "9",
      "sm": "6",
      "xs": "12"
    }
  }, [_c('b-card', {
    scopedSlots: _vm._u([{
      key: "header",
      fn: function() {
        return [_c('b-row', [_c('b-col', {
          attrs: {
            "cols": "9"
          }
        }, [_c('h4', {
          staticClass: "card-title"
        }, [_vm._v("Disk")])]), _vm._v(" "), _c('b-col', {
          staticClass: "text-right",
          attrs: {
            "cols": "3"
          }
        }, [_c('icon', {
          attrs: {
            "name": "hdd",
            "scale": "1"
          }
        })], 1)], 1)]
      },
      proxy: true
    }], null, false, 2122568809)
  }, [_vm._v(" "), _c('b-card-text', [_c('line-chart', {
    ref: "disksTrendChart",
    attrs: {
      "chartData": _vm.disks.trend.chartData,
      "options": _vm.disks.trend.chartOptions
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2 mb-2",
    attrs: {
      "lg": "6",
      "md": "6",
      "sm": "6",
      "xs": "12"
    }
  }, [_c('b-card', {
    scopedSlots: _vm._u([{
      key: "header",
      fn: function() {
        return [_c('b-row', [_c('b-col', {
          attrs: {
            "cols": "9"
          }
        }, [_c('h4', {
          staticClass: "card-title"
        }, [_vm._v("Disk Activity")])]), _vm._v(" "), _c('b-col', {
          staticClass: "text-right",
          attrs: {
            "cols": "3"
          }
        }, [_c('icon', {
          attrs: {
            "name": "hdd",
            "scale": "1"
          }
        })], 1)], 1)]
      },
      proxy: true
    }], null, false, 2356794756)
  }, [_vm._v(" "), _c('b-card-text', [_c('line-chart', {
    ref: "disksActivityTrendChart",
    attrs: {
      "chartData": _vm.disks.activity.chartData,
      "options": _vm.disks.activity.chartOptions
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2 mb-2",
    attrs: {
      "lg": "6",
      "md": "6",
      "sm": "6",
      "xs": "12"
    }
  }, [_c('b-card', {
    scopedSlots: _vm._u([{
      key: "header",
      fn: function() {
        return [_c('b-row', [_c('b-col', {
          attrs: {
            "cols": "9"
          }
        }, [_c('h4', {
          staticClass: "card-title"
        }, [_vm._v("Network Activity")])]), _vm._v(" "), _c('b-col', {
          staticClass: "text-right",
          attrs: {
            "cols": "3"
          }
        }, [_c('icon', {
          attrs: {
            "name": "network-wired",
            "scale": "1"
          }
        })], 1)], 1)]
      },
      proxy: true
    }], null, false, 2230381369)
  }, [_vm._v(" "), _c('b-card-text', [_c('line-chart', {
    ref: "networkTrendChart",
    attrs: {
      "chartData": _vm.network.chartData,
      "options": _vm.network.chartOptions
    }
  })], 1)], 1)], 1)], 1)], 1) : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1e9cab16","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/dashboard/ServerDashboardPage.vue
// module id = 2140
// module chunks = 1